import React from 'react';
import ReactDOM from 'react-dom';
import OkrAlignmentTable from './components/okr/okr-alignment-table';

const RenderGoalAlignsComp = (props = {}, ele) => {
  if (ele) {
    ReactDOM.render(
      <OkrAlignmentTable
        key={`goal_aligns_${props.goalId}`}
        wrapperClass="wb-ghead-alignspopup-wrapper"
        filterValue="5"
        showTitle={false}
        showHeader={false}
        {...props}
      />, ele,
    );
  }
};

window.RenderGoalAlignsComp = RenderGoalAlignsComp;
